import { useAuthUserGetSberOauthUriQuery } from 'domain/api/graphql/generated';
import { FetchPolicyKeys } from 'domain/api/graphql/types';

export type useSBBIDType = {
  redirectPath: string;
};

const useSBBID = ({ redirectPath }: useSBBIDType) => {
  const query = useAuthUserGetSberOauthUriQuery({
    fetchPolicy: FetchPolicyKeys.CACHE_AND_NETWORK,
    variables: { redirect: redirectPath },
  });

  return {
    error: query.error,
    loading: query.loading,
    data: {
      uri: query.data?.userGetSberOauthUri,
    },
  };
};

export default useSBBID;
